<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="$emit('close')">
            <div class="absolute inset-0 overflow-hidden" :class="{ 'dark': store.state.global.isDark }">
                <DialogOverlay class="absolute inset-0" />
                <div class="fixed inset-y-0 right-0 max-w-full flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-md">
                            <div class="mt-16 h-full flex flex-col bg-white dark:bg-gray-700 shadow-xl overflow-hidden h-screen">
                                <div class="p-6 border-b border-dashed">
                                    <div class="flex items-start justify-between">
                                        <DialogTitle class="text-lg font-medium text-gray-900 dark:text-white">
                                            Notifications
                                        </DialogTitle>
                                        <div class="ml-3 h-7 flex items-center">
                                            <button type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-white" @click="$emit('close')">
                                                <span class="sr-only">Close panel</span>
                                                <XIcon class="h-6 w-6" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ul role="list" class="flex-1 divide-y divide-gray-200 overflow-y-auto bg-gray-750 h-full" v-if="notifications && notifications.length">
                                    <li v-for="notification in notifications" :key="notification.id">
                                        <div class="relative group py-6 px-5 flex items-center dark:bg-gray-900 relative">
                                            <a href="#" @click="performAction(notification)" class="-m-1 flex-1 block p-1">
                                                <div class="absolute inset-0 group-hover:bg-gray-50 dark:group-hover:bg-gray-800" aria-hidden="true" />
                                                <div class="flex-1 flex items-center min-w-0 relative">
                                                    <div class="ml-4 truncate">
                                                        <p class="text-sm font-medium text-gray-900 dark:text-white truncate">{{ notification.data.title }}</p>

                                                        <p class="text-sm text-gray-500 dark:text-white truncate">{{ moment(notification.created_at).format('ddd, MMM Do, h:mm a') }}</p>
<!--                                                        Add button here -->
                                                    </div>
                                                </div>
                                            </a>
                                            <div class="ml-2 shrink-0 inline-block text-left absolute top-2 right-2">
                                                <XIconSolid class="dark:text-white w-10 cursor-pointer rounded-full p-2 dark:hover:bg-gray-900 dark:hover:text-racing-stars-yellow" @click.prevent="deleteNotification(notification)" />
                                            </div>
                                        </div>
                                    </li>
                                    <button  @click.prevent="deleteAllNotifications(notifications)"
                                             class="items-center px-4 py-2 text-base font-medium absolute shadow-sm w-full text-gray-900 bg-racing-stars-yellow fixed bottom-0"
                                    >
                                        Clear All
                                    </button>
                                </ul>
                                <div class="text-gray-800 p-8 dark:text-white" v-else>
                                    No Notifications Available
                                </div>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import { ref, computed, onMounted } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3'
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'
import { XIcon } from '@heroicons/vue/outline'
import { XIcon as XIconSolid } from '@heroicons/vue/solid'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import { useStore } from 'vuex'
import moment from 'moment'

export default {
    emits: ['deleteNotification', 'updateNotification', 'close'],


	props: {
		notifications: Object
	},
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        TransitionChild,
        TransitionRoot,
        RacingStarsIcon,
        XIcon,
        XIconSolid,
        Link,
    },
    setup(props, { emit }) {
        const windowWidth = ref(window.innerWidth)
        const windowHeight = ref(window.innerHeight)

        const open = ref(false)

        const store = useStore()

        const setWindowDimensions = () => {
            windowWidth.value = window.innerWidth
            windowHeight.value = window.innerHeight
        }

        const performAction = (notification) => {
            emit('updateNotification', notification)
        }

        const deleteNotification = (notification) => {
            emit('deleteNotification', notification)
        }

        const deleteAllNotifications = (notifications) => {
            notifications.forEach(function(key) {
                emit('deleteNotification', key)
            });


        }

        /**
         * Mounted.
         */
        onMounted(() => {
            setWindowDimensions()

            window.addEventListener('resize', setWindowDimensions)
        })

        return {
            open,
            store,
            deleteNotification,
            deleteAllNotifications,
            moment,
            performAction,
        }
    },
}

</script>
